import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { QuestionAnswer } from "@/types";

export interface QuestionsState {
  answers: QuestionAnswer;
  errors: { [key: string]: string };
  status: "idle" | "fetching" | "saving";
}

const initialState: Partial<QuestionsState> = {
  answers: {},
  errors: {},
  status: "idle"
};

export const questionsSlice = createSlice({
  name: "questions",
  initialState,
  reducers: {
    setAnswer: (state, action) => {
      const { questionId, answer } = action.payload;

      delete state.errors[questionId];
      state.answers[questionId] = answer;
    },
    setError: (state, action) => {
      const { questionId, error } = action.payload;

      state.errors[questionId] = error ? error : "";
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setAllAnswers: (state, action) => {
      state.answers = { ...state.answers, ...action.payload };
    },
    resetAnswers: (state) => {
      state.answers = initialState.answers;
      state.status = "idle";
    },
    removeAnswer: (state, action) => {
      const questionId = action.payload;
      delete state.answers[questionId];
    },
    clearAllErrors: (state) => {
      state.errors = initialState.errors;
      state.status = "idle";
    }
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action: PayloadAction<string>) => {
      return {
        ...state,
        ...action.payload[questionsSlice.name]
      };
    });
  }
});

export const {
  setAnswer,
  setError,
  setStatus,
  resetAnswers,
  setAllAnswers,
  clearAllErrors,
  removeAnswer
} = questionsSlice.actions;
